module.exports = __webpack_public_path__ + "r-v3/img/loading_gooroomee.4afcb0ea.gif";